<div class="d-inline-block" ngbDropdown placement="bottom-end">
  <button
    data-dd-action-name="regime-selector.regime-menu-button"
    type="button"
    id="regime-selection"
    class="btn btn-primary"
    [disabled]="!regimes.length"
    ngbDropdownToggle
  >
    <i-lucide [name]="getIconName(selectedRegime)"></i-lucide>

    @if (selectedRegime) {
      {{ selectedRegime && selectedRegime.name }} View
    } @else {
      <em>(Loading views&hellip;)</em>
    }
  </button>
  <div ngbDropdownMenu aria-labelledby="regime-selection">
    @for (regime of regimes; track regime) {
      <button
        data-dd-action-name="regime-selector.regime-button"
        type="button"
        ngbDropdownItem
        [class.active]="selectedRegime && regime.id === selectedRegime.id"
        (click)="onUserChangedRegime(regime.id)"
      >
        <i-lucide [name]="getIconName(regime)"></i-lucide>

        {{ regime.name }} View
      </button>
    }
  </div>
</div>
